export default __webpack_public_path__ + "static/media/capstone_pipeline.21687077.png";